import type { Channel } from '@t/productOffering.types';
import { ChannelLogo } from '@shared/components/display/ChannelLogo/ChannelLogo';

export const ChannelHoverCard = ({ channel }: { channel: Channel }) => (
  <ChannelLogo src={channel.descriptionImage ?? channel.logo} name={channel.name} width={378} height={326} />
);
